const meta = {
  'monitor-kubernetes': 'Monitor Kubernetes metrics',
  'scrape-configuration': 'Scrape',
};

export default meta;
